import { useTranslation } from 'react-i18next'
import { NotFound } from '~/shared/ui/NotFound'

export const NoAccess = () => {
  const { t } = useTranslation()
  return <NotFound message={t('alert.you do not have access to this page')} />
}
